import { ApiError, apiRequest } from '@/lib/api-client';
import {
  assertAnalyticsResponseScope,
  normalizeAnalyticsAddress
} from '@/lib/investor-analytics';
import {
  investorTransactionsQuerySchema,
  investorTransactionsResponseSchema,
  mapInvestorTransactions,
  type InvestorTransactionsQuery,
  type InvestorTransactionsResponse
} from '../types/api';

export async function fetchInvestorTransactions(
  address: string,
  params: InvestorTransactionsQuery,
  chainId: number,
  signal?: AbortSignal
): Promise<InvestorTransactionsResponse> {
  const investor = normalizeAnalyticsAddress(address);
  const pagination = investorTransactionsQuerySchema.parse(params);
  const response = await apiRequest(
    `/api/v1/investor/${encodeURIComponent(investor)}/transactions`,
    investorTransactionsResponseSchema,
    {
      auth: 'required',
      chainId,
      query: pagination,
      signal
    }
  );

  assertAnalyticsResponseScope(investor, chainId, response);
  if (
    response.page !== pagination.page ||
    response.limit !== pagination.limit
  ) {
    throw new ApiError('ROWA returned data that could not be verified.', {
      status: 200,
      code: 'invalid-response'
    });
  }

  return mapInvestorTransactions(response);
}
